import { WorkspaceAvatar } from '../../WorkspaceAvatar';
import TEXT from './generated/TEXT/InvitedToNavItem';
import { StyledListItemContent } from './NavItem.styles';

export function InvitedToNavItem() {
  return (
    <StyledListItemContent
      adornmentBefore={
        <WorkspaceAvatar
          alt={TEXT.invitedTo}
          avatar="invitedTo"
          size={AVATAR_SIZE}
        />
      }
      label={TEXT.invitedTo}
    />
  );
}
const AVATAR_SIZE = 20;
TEXT.DEFINE({
  /** Label for the invited-to workspace list item */
  invitedTo: 'Invited to',
});
